import { render, staticRenderFns } from "./CreateCustomerUserName.vue?vue&type=template&id=280b6e2f&"
import script from "./CreateCustomerUserName.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerUserName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports